// extracted by mini-css-extract-plugin
export var active = "navigation-module--active--1lGXk";
export var nav_item = "navigation-module--nav_item--AXY0P";
export var nav_link = "navigation-module--nav_link--Mw6SA";